// // // // import React, { useState } from 'react';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

// // // // const EnterSchoolId = () => {
// // // //   const [schoolId, setSchoolId] = useState('');
// // // //   const [error, setError] = useState('');
// // // //   const [loading, setLoading] = useState(false);
// // // //   const navigate = useNavigate();

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();

// // // //     if (!schoolId.trim()) {
// // // //       setError('Enter a valid School ID.');
// // // //       return;
// // // //     }

// // // //     setLoading(true);
// // // //     setError('');

// // // //     try {
// // // //       const res = await fetch(`/api/schools/get?schoolId=${schoolId.trim()}`);
// // // //       const data = await res.json();

// // // //       if (!data.success) {
// // // //         setError(data.message || 'School not found.');
// // // //         return;
// // // //       }

// // // //       navigate(`/school/${schoolId.trim()}`);
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       setError('Something went wrong. Please try again later.');
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <section className="w-full py-4 px-4 flex justify-center">
// // // //       <div className="w-full max-w-3xl bg-slate-900/70 backdrop-blur-md border border-slate-700 shadow-lg rounded-xl px-6 py-4">

// // // //         <form
// // // //           onSubmit={handleSubmit}
// // // //           className="flex flex-col md:flex-row items-center justify-between gap-4"
// // // //         >
// // // //           <span className="flex items-center gap-2 text-white text-sm md:text-base font-medium whitespace-nowrap">
// // // //             <AcademicCapIcon className="h-5 w-5 text-indigo-400" />
// // // //             Get your school:
// // // //           </span>

// // // //           <input
// // // //             type="text"
// // // //             placeholder="Enter School ID"
// // // //             value={schoolId}
// // // //             onChange={(e) => {
// // // //               setSchoolId(e.target.value.toUpperCase());
// // // //               setError('');
// // // //             }}
// // // //             className="flex-1 min-w-0 px-4 py-2 rounded-lg bg-slate-800 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400 text-sm"
// // // //           />

// // // //           <button
// // // //             type="submit"
// // // //             disabled={loading}
// // // //             className="px-5 py-2 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 transition duration-200 rounded-lg text-white text-sm font-semibold shadow-md disabled:opacity-50"
// // // //           >
// // // //             {loading ? (
// // // //               <svg
// // // //                 className="animate-spin h-4 w-4 text-white"
// // // //                 xmlns="http://www.w3.org/2000/svg"
// // // //                 fill="none"
// // // //                 viewBox="0 0 24 24"
// // // //               >
// // // //                 <circle
// // // //                   className="opacity-25"
// // // //                   cx="12"
// // // //                   cy="12"
// // // //                   r="10"
// // // //                   stroke="currentColor"
// // // //                   strokeWidth="4"
// // // //                 ></circle>
// // // //                 <path
// // // //                   className="opacity-75"
// // // //                   fill="currentColor"
// // // //                   d="M4 12a8 8 0 018-8v8H4z"
// // // //                 ></path>
// // // //               </svg>
// // // //             ) : (
// // // //               <>
// // // //                 Go <ArrowRightIcon className="h-4 w-4" />
// // // //               </>
// // // //             )}
// // // //           </button>
// // // //         </form>

// // // //         {error && (
// // // //           <p className="text-red-500 text-xs md:text-sm mt-2 text-center">
// // // //             {error}
// // // //           </p>
// // // //         )}
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default EnterSchoolId;


// // // import React, { useState } from 'react';
// // // import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

// // // const EnterSchoolId = () => {
// // //   const [schoolId, setSchoolId] = useState('');
// // //   const [error, setError] = useState('');
// // //   const [loading, setLoading] = useState(false);

// // //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     if (!schoolId.trim()) {
// // //       setError('Enter a valid School ID.');
// // //       return;
// // //     }

// // //     setLoading(true);
// // //     setError('');

// // //     try {
// // //       const normalizedId = schoolId.trim().toUpperCase();
// // //       const res = await fetch(`${BACKEND_URL}/api/v1/getSchoolUrlById/${normalizedId}`);

// // //       const data = await res.json();

// // //       if (!data.success || !data.schoolUrl) {
// // //         setError(data.message || 'School not found.');
// // //         return;
// // //       }

// // //       console.log(data.schoolUrl);

// // //       // ✅ Open the school site in a new tab
// // //       window.open(data.schoolUrl, '_blank');
// // //     } catch (err) {
// // //       console.error(err);
// // //       setError('Something went wrong. Please try again later.');
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   return (
// // //     <section className="w-full py-4 px-4 flex justify-center">
// // //       <div className="w-full max-w-3xl bg-slate-900/70 backdrop-blur-md border border-slate-700 shadow-lg rounded-xl px-6 py-4">

// // //         <form
// // //           onSubmit={handleSubmit}
// // //           className="flex flex-col md:flex-row items-center justify-between gap-4"
// // //         >
// // //           <span className="flex items-center gap-2 text-white text-sm md:text-base font-medium whitespace-nowrap">
// // //             <AcademicCapIcon className="h-5 w-5 text-indigo-400" />
// // //             Get your school:
// // //           </span>

// // //           <input
// // //             type="text"
// // //             placeholder="Enter School ID"
// // //             value={schoolId}
// // //             onChange={(e) => {
// // //               setSchoolId(e.target.value.toUpperCase());
// // //               setError('');
// // //             }}
// // //             className="flex-1 min-w-0 px-4 py-2 rounded-lg bg-slate-800 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400 text-sm"
// // //           />

// // //           <button
// // //             type="submit"
// // //             disabled={loading}
// // //             className="px-5 py-2 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 transition duration-200 rounded-lg text-white text-sm font-semibold shadow-md disabled:opacity-50"
// // //           >
// // //             {loading ? (
// // //               <svg
// // //                 className="animate-spin h-4 w-4 text-white"
// // //                 xmlns="http://www.w3.org/2000/svg"
// // //                 fill="none"
// // //                 viewBox="0 0 24 24"
// // //               >
// // //                 <circle
// // //                   className="opacity-25"
// // //                   cx="12"
// // //                   cy="12"
// // //                   r="10"
// // //                   stroke="currentColor"
// // //                   strokeWidth="4"
// // //                 ></circle>
// // //                 <path
// // //                   className="opacity-75"
// // //                   fill="currentColor"
// // //                   d="M4 12a8 8 0 018-8v8H4z"
// // //                 ></path>
// // //               </svg>
// // //             ) : (
// // //               <>
// // //                 Go <ArrowRightIcon className="h-4 w-4" />
// // //               </>
// // //             )}
// // //           </button>
// // //         </form>

// // //         {error && (
// // //           <p className="text-red-500 text-xs md:text-sm mt-2 text-center">
// // //             {error}
// // //           </p>
// // //         )}
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default EnterSchoolId;


// // import React, { useState } from 'react';
// // import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

// // const EnterSchoolId = () => {
// //   const [schoolId, setSchoolId] = useState('');
// //   const [error, setError] = useState('');
// //   const [loading, setLoading] = useState(false);

// //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!schoolId.trim()) {
// //       setError('Enter a valid School ID.');
// //       return;
// //     }

// //     setLoading(true);
// //     setError('');

// //     try {
// //       const normalizedId = schoolId.trim().toUpperCase();
// //       const res = await fetch(`${BACKEND_URL}/api/v1/getSchoolUrlById/${normalizedId}`);
// //       const data = await res.json();

// //       if (!data.success || !data.schoolUrl) {
// //         setError(data.message || 'School not found.');
// //         return;
// //       }

// //       window.open(data.schoolUrl, '_blank');
// //     } catch (err) {
// //       console.error(err);
// //       setError('Something went wrong. Please try again later.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <section className="w-full pt-6 px-4 flex justify-center">
// //       <div className="w-full max-w-3xl bg-white border border-[#E3E8F0] shadow-[0_8px_24px_-16px_rgba(16,24,38,0.2)] rounded-2xl px-6 py-4">
// //         <form
// //           onSubmit={handleSubmit}
// //           className="flex flex-col md:flex-row items-center justify-between gap-4"
// //         >
// //           <span className="flex items-center gap-2 text-[#163863] text-sm md:text-base font-['Sora',sans-serif] font-semibold whitespace-nowrap">
// //             <AcademicCapIcon className="h-5 w-5 text-[#E8A63C]" />
// //             Already registered? Find your school
// //           </span>

// //           <input
// //             type="text"
// //             placeholder="Enter School ID"
// //             value={schoolId}
// //             onChange={(e) => {
// //               setSchoolId(e.target.value.toUpperCase());
// //               setError('');
// //             }}
// //             className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-[#F4F8FC] border border-[#E3E8F0] focus:outline-none focus:ring-2 focus:ring-[#2E63B8]/40 focus:border-[#2E63B8] text-[#101826] placeholder-[#8891A0] font-['Sora',sans-serif] text-sm"
// //           />

// //           <button
// //             type="submit"
// //             disabled={loading}
// //             className="px-5 py-2.5 flex items-center gap-2 bg-[#163863] hover:bg-[#2E63B8] transition-colors duration-200 rounded-lg text-white font-['Sora',sans-serif] text-sm font-semibold shadow-sm disabled:opacity-50"
// //           >
// //             {loading ? (
// //               <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
// //                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
// //                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
// //               </svg>
// //             ) : (
// //               <>
// //                 Go <ArrowRightIcon className="h-4 w-4" />
// //               </>
// //             )}
// //           </button>
// //         </form>

// //         {error && (
// //           <p className="text-red-600 text-xs md:text-sm mt-2 text-center font-['Sora',sans-serif]">
// //             {error}
// //           </p>
// //         )}
// //       </div>
// //     </section>
// //   );
// // };

// // export default EnterSchoolId;


// import React, { useState } from 'react';
// import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

// const EnterSchoolId = () => {
//   const [schoolId, setSchoolId] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!schoolId.trim()) {
//       setError('Enter a valid School ID.');
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       const normalizedId = schoolId.trim().toUpperCase();
//       const res = await fetch(`${BACKEND_URL}/api/v1/getSchoolUrlById/${normalizedId}`);
//       const data = await res.json();

//       if (!data.success || !data.schoolUrl) {
//         setError(data.message || 'School not found.');
//         return;
//       }

//       window.open(data.schoolUrl, '_blank');
//     } catch (err) {
//       console.error(err);
//       setError('Something went wrong. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="w-full pt-10 md:pt-14 pb-4 px-4 md:px-6 bg-gradient-to-b from-[#EAF1FB] to-white flex justify-center">
//       <div className="w-full max-w-3xl relative overflow-hidden bg-white border border-[#D8E4F5] shadow-[0_20px_45px_-24px_rgba(22,56,99,0.4)] rounded-2xl px-6 py-5">
//         <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#E8A63C]" />

//         <form
//           onSubmit={handleSubmit}
//           className="flex flex-col md:flex-row items-center justify-between gap-4"
//         >
//           <span className="flex items-center gap-2 text-[#163863] text-sm md:text-base font-['Sora',sans-serif] font-semibold whitespace-nowrap">
//             <AcademicCapIcon className="h-5 w-5 text-[#E8A63C]" />
//             Already registered? Find your school
//           </span>

//           <input
//             type="text"
//             placeholder="Enter School ID"
//             value={schoolId}
//             onChange={(e) => {
//               setSchoolId(e.target.value.toUpperCase());
//               setError('');
//             }}
//             className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-[#F4F8FC] border border-[#C7D6EC] focus:outline-none focus:ring-2 focus:ring-[#2E63B8]/40 focus:border-[#2E63B8] text-[#101826] placeholder-[#8891A0] font-['Sora',sans-serif] text-sm"
//           />

//           <button
//             type="submit"
//             disabled={loading}
//             className="px-5 py-2.5 flex items-center gap-2 bg-[#163863] hover:bg-[#2E63B8] transition-colors duration-200 rounded-lg text-white font-['Sora',sans-serif] text-sm font-semibold shadow-sm disabled:opacity-50"
//           >
//             {loading ? (
//               <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
//               </svg>
//             ) : (
//               <>
//                 Go <ArrowRightIcon className="h-4 w-4" />
//               </>
//             )}
//           </button>
//         </form>

//         {error && (
//           <p className="text-red-600 text-xs md:text-sm mt-2 text-center font-['Sora',sans-serif]">
//             {error}
//           </p>
//         )}
//       </div>
//     </section>
//   );
// };

// export default EnterSchoolId;

import React, { useState } from 'react';
import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

const EnterSchoolId = () => {
  const [schoolId, setSchoolId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!schoolId.trim()) {
      setError('Enter a valid School ID.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const normalizedId = schoolId.trim().toUpperCase();
      const res = await fetch(`${BACKEND_URL}/api/v1/getSchoolUrlById/${normalizedId}`);
      const data = await res.json();

      if (!data.success || !data.schoolUrl) {
        setError(data.message || 'School not found.');
        return;
      }

      window.open(data.schoolUrl, '_blank');
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="find-school"
      className="scroll-mt-[88px] w-full pt-10 md:pt-14 pb-4 px-4 md:px-6 bg-gradient-to-b from-[#EAF1FB] to-white flex justify-center"
      style={{ fontFamily: "'Sora', sans-serif" }}
    >
      <div className="w-full max-w-3xl relative overflow-hidden bg-white border border-[#D8E4F5] shadow-[0_20px_45px_-24px_rgba(22,56,99,0.4)] rounded-2xl px-6 py-5">
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#E8A63C]" />

        <form
          onSubmit={handleSubmit}
          className="flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <span className="flex items-center gap-2 text-[#163863] text-sm md:text-base font-semibold whitespace-nowrap">
            <AcademicCapIcon className="h-5 w-5 text-[#E8A63C]" />
            Already registered? Find your school
          </span>

          <input
            type="text"
            placeholder="Enter School ID"
            value={schoolId}
            onChange={(e) => {
              setSchoolId(e.target.value.toUpperCase());
              setError('');
            }}
            className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-[#F4F8FC] border border-[#C7D6EC] text-[#101826] placeholder-[#8891A0] text-sm outline-none transition-[box-shadow,border-color] duration-200 ease-out focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.15)]"
            style={{ outline: 'none' }}
          />

          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2.5 flex items-center gap-2 bg-[#163863] hover:bg-[#2E63B8] transition-colors duration-200 rounded-lg text-white text-sm font-semibold shadow-sm disabled:opacity-50"
          >
            {loading ? (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            ) : (
              <>
                Go <ArrowRightIcon className="h-4 w-4" />
              </>
            )}
          </button>
        </form>

        {error && (
          <p className="text-red-600 text-xs md:text-sm mt-2 text-center">
            {error}
          </p>
        )}
      </div>
    </section>
  );
};

export default EnterSchoolId;

